import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "src/core/services/authentication.service";

@Component({
  selector: "app-login",
  // imports: [],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.css",
  standalone: false,
})
export class LoginComponent implements OnInit {
  user: any;
  isAdmin: any;
  sessionEndDate: any;
  isLoggedIn = false;
  isTokenPresent = false;
  countdown = 1000;
  name: any = "";
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.checkLoggedIn();
    if (!this.isLoggedIn) {
      this.logout();
      this.router.createUrlTree(["login"]);
    }
    this.isTokenPresent = this.authenticationService.isAccessTokenPresent();
    if (this.isTokenPresent) {
      this.sessionEndDate = new Date(
        Number(localStorage.getItem("expires_at"))
      );
    }
    // @ts-ignore
    this.name = localStorage.getItem("name");
  }

  login() {
    this.authenticationService.obtainAccessToken();
  }

  checkLoggedIn() {
    this.isLoggedIn = this.authenticationService.isLoggedIn();
  }

  ngDoCheck() {
    // @ts-ignore
    this.user = localStorage.getItem("name");
    this.isAdmin = localStorage.getItem("isAdmin");
  }

  logout() {
    this.user = null;
    this.authenticationService.logout();
    this.isLoggedIn = false;
    this.isTokenPresent = false;
    localStorage.clear();
  }
}
